import type { GenerationAction, TreeNode } from "../context/types";

/**
 * Derives a display title and subtitle from a tree node's actions.
 * Used by HistoryPanel to label each history entry.
 */
export function getNodeSummary({
  node,
  t,
}: {
  node: TreeNode;
  t: (key: string) => string;
}): { title: string; subtitle: string | null } {
  if (node.parent_photo_id === null) {
    return { title: t("interiorDesigner.history.rootLabel"), subtitle: null };
  }

  const action: GenerationAction | undefined = node.actions?.[0];
  if (!action) {
    return {
      title: t("interiorDesigner.history.generated"),
      subtitle: null,
    };
  }

  switch (action.type) {
    case "interior_finishing": {
      const parts = [action.floor, action.wall].filter(Boolean);
      return {
        title: t("interiorDesigner.chips.interiorFinishing"),
        subtitle: parts.length > 0 ? parts.join(", ") : null,
      };
    }
    case "furnishing": {
      const parts = [action.style, action.room_type].filter(Boolean);
      return {
        title: t("interiorDesigner.chips.furnishing"),
        subtitle: parts.length > 0 ? parts.join(" - ") : null,
      };
    }
    case "wall_color": {
      let subtitle: string | null = null;
      if (action.ral_code) {
        subtitle = action.ral_code;
      } else if (action.custom_text) {
        subtitle = `"${action.custom_text}"`;
      }
      return {
        title: t("interiorDesigner.chips.wallColor"),
        subtitle,
      };
    }
    case "other_wishes":
      return {
        title: t("interiorDesigner.chips.otherWishes"),
        subtitle: `"${action.text}"`,
      };
    case "remove_furniture":
      return {
        title: t("interiorDesigner.history.removeFurniture"),
        subtitle: null,
      };
    case "day_night":
      return {
        title: t("interiorDesigner.history.dayNight"),
        subtitle: action.mode,
      };
    default:
      return {
        title: t("interiorDesigner.history.generated"),
        subtitle: null,
      };
  }
}
